export { default } from './getCompany';
export * from './getCompany';
